var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyMealwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My Meal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.83333 17.7105V16.0439C2.83636 13.7583 3.69233 11.5562 5.23367 9.86856C6.77501 8.18095 8.89074 7.12938 11.1667 6.91971V5.81305C10.8489 5.6296 10.6006 5.34644 10.4602 5.00748C10.3198 4.66851 10.2952 4.29269 10.3901 3.9383C10.4851 3.58392 10.6943 3.27076 10.9854 3.04741C11.2765 2.82407 11.6331 2.703 12 2.703C12.3669 2.703 12.7235 2.82407 13.0146 3.04741C13.3057 3.27076 13.5149 3.58392 13.6099 3.9383C13.7048 4.29269 13.6802 4.66851 13.5398 5.00748C13.3994 5.34644 13.1511 5.6296 12.8333 5.81305V6.91971C15.1093 7.12938 17.225 8.18095 18.7663 9.86856C20.3077 11.5562 21.1636 13.7583 21.1667 16.0439V17.7105H2.83333ZM2 19.3772V21.0439H22V19.3772H2Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMealwhite);
export default __webpack_public_path__ + "static/media/My Meal white.45d6f5845e9f9c5173508746665a16df.svg";
export { ForwardRef as ReactComponent };